import { FunctionComponent, useEffect, useMemo } from 'react'

import styled, { css } from 'styled-components'

import { useChatbotTypingEffect } from '@hooks/useChatbot/useChatbotTypingEffect'

import { TypingEffectWrapperProps } from '../types'

const ANIMATION_TIME_CONSTANT = 13.33
const ANIMATION_TIME_OFFSET = 333.33

const StyledFadeInChar = styled.span<{
  animationDelay: number
  animationDuration: number
}>`
  ${({ animationDelay, animationDuration }) => css`
    @keyframes fadeInTypingAnimation {
      to {
        opacity: 1;
      }
    }
    opacity: 0;
    animation: fadeInTypingAnimation ${animationDuration}ms ease forwards;
    animation-delay: ${animationDelay}ms;
  `}
`

const TypingAnimationWrapper: FunctionComponent<TypingEffectWrapperProps> = ({
  text,
  afterText,
  skipAnimation,
  afterTypingEffectEndCb,
  time = 20,
}) => {
  const animationDuration = useMemo(
    () => ANIMATION_TIME_CONSTANT * time + ANIMATION_TIME_OFFSET,
    [time]
  )

  const { visibleChars, animationFinished } = useChatbotTypingEffect(
    animationDuration,
    text,
    time,
    skipAnimation
  )

  useEffect(() => {
    if (animationFinished) afterTypingEffectEndCb?.()
  }, [animationFinished, afterTypingEffectEndCb])

  return (
    <>
      {!animationFinished && (
        <span translate="no">
          {visibleChars.map(({ char, key, delay }) => (
            <StyledFadeInChar
              key={key}
              animationDelay={delay}
              animationDuration={animationDuration}>
              {char}
            </StyledFadeInChar>
          ))}
        </span>
      )}

      {animationFinished && (
        <>
          <span>{text}</span>
          {afterText}
        </>
      )}
    </>
  )
}

export default TypingAnimationWrapper
